module.exports = new __parcel__URL__("icons8-gmail.014cd6f9.svg").toString();